<template>
  <div class="record-container"
       v-loading.fullscreen="fullscreenLoading">
    <div class="title">
      TK直播录制工具
    </div>
    <div class="intro-code-box">
      <div class="intro">
        TK后勤部目前专注于TikTok服务商领域，主要服务对象为TikTok从业人员，力求以真诚靠谱的服务与产品来满足大家运营过程中的相关需求。
        <br />目前主要提供以下三块服务：<br />
        <strong>
          · 硬件类（如二手工作机／办公电脑/全球海外运营商废卡/运营商专线/软路由等）<br />
          · 软件类（如账号云控／无人直播系统/店群ERP/达人邀约软件等）<br />
          · 资源信息类（小店售卖和代开／小店补单/刷粉刷赞/官方机构代开/店铺报白/金币充值等）<br />
        </strong><br />
        业务对接可联系右边二维码👉🏻
      </div>
      <div class="code">
        <img src="../../assets/down-code.png"
             alt="">
      </div>
    </div>
    <div class="input-tool-box">
      <div class="input-box">
        <input type="text"
               v-model="userId"
               placeholder="请输入直播间用户ID">
        <div @click="getDownload"
             class="btn">
          获取
        </div>
      </div>
      <a class="download-tool"
         href=" https://www.aliyundrive.com/s/E6rBj5MFqhR"
         target="blank">
        ※直播间下载教程及工具-点此下载</a>
    </div>
    <div class="get-url"
         v-if="downloadUrl">
      直播下载链接: {{ downloadUrl }}
    </div>
    <div class="teach-box">
      <div class="pro-box">
        <div class="tip">
          ※TK直播录制工具分为免费版本及付费版本（可监控录制）※
          <br /><br />付费版本软件界面👉🏻
        </div>
        <img src="../../assets/pro-bg.png"
             alt="">
      </div>
      <div class="teach-title">
        免费版本使用教程:
      </div>
      <div class="teach-first-second">
        <div class="first step">
          <div class="num">
            1
          </div>
          <div class="detail">
            打开TK后勤部官网<br />
            https://www.tkhouqin.com/zhiboxiazai
          </div>
        </div>
      </div>
      <div class="teach-second">
        <div class="teach-second-left">
          <div class="num">
            2
          </div>
          <div class="detail">
            选择要录制的博主ID（即博主个人主页@后面的那串）<br />粘贴并点击获取（若获取不成功就刷新几次网页，或者换个网络环境，用国内网）
          </div>
        </div>
        <img src="../../assets/live-id.png"
             alt="">
      </div>
      <div class="teach-third">
        <div class="num">
          3
        </div>
        <div class="detail">
          打开下载好的素材下载工具<br />
          将博主id作为视频标题<br />
          将复制好的下载链接添加到M3MU8地址（下载时使用的IP需要用外网）
        </div>
        <img src="../../assets/teach-1.png"
             alt="">
      </div>
      <div class="teach-fourth">
        <div class="teach-fourth-left">
          <div class="num">
            4
          </div>
          <div class="detail">
            点击右下角GO，弹出以下界面即成功<br />
            如果出现画面不动，重新点下GO就好<br />
            不想录了直接X掉就行
          </div>
        </div>
        <img src="../../assets/teach-2.png"
             alt="">
      </div>
      <div class="teach-fifth">
        <div class="num">
          5
        </div>
        <div class="detail">
          关闭窗口完成录制
        </div>
      </div>
    </div>
    <img class="business"
         src="../../assets/business.jpg"
         alt="">
  </div>
</template>

<script>
import { getDownload } from "@/api/home"
import { Message } from 'element-ui'
export default {
  data () {
    return {
      userId: '',
      downloadUrl: '',
      fullscreenLoading: false,
    }
  },
  methods: {
    async getDownload () {

      if (localStorage.getItem('token')) {
        this.fullscreenLoading = true
        const res = await getDownload({ id: this.userId })
        if (res.code == 10000) {
          this.downloadUrl = res.data.url
          this.fullscreenLoading = false
        } else {
          this.fullscreenLoading = false
          Message({
            message: res.msg,
            type: 'error',
            duration: 5 * 1000
          })
        }
      } else {
        Message({
          message: '请先登录',
          type: 'error',
          duration: 5 * 1000
        })
      }

    }
  }
}
</script>

<style lang="less" scoped>
.record-container {
  width: 1200px;
  margin: 30px auto 30px;
  padding-left: 20px;
  box-sizing: border-box;
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-left: 24px;
  }
  .intro-code-box {
    display: flex;
    margin-top: 20px;
    .intro {
      width: 750px;
      padding: 15px 20px;
      background: #eeeeee;
      border-radius: 5px;
      font-size: 14px;
    }
    .code {
      margin-left: 82px;
      img {
        width: 130px;
        height: 130px;
      }
    }
  }
  .input-tool-box {
    margin-top: 20px;
    display: flex;
    align-items: center;
    .input-box {
      width: 400px;
      display: flex;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #3898ff;
      input {
        flex: 1;
        border-radius: 12px 0 0 12px;
        padding-left: 20px;
        font-size: 16px;
        border: none;
      }
      .btn {
        padding: 13px 32px;
        background: #3898ff;
        color: #ffffff;
        border-radius: 0px 12px 12px 0px;
        cursor: pointer;
      }
    }
    .download-tool {
      font-size: 18px;
      color: #3898ff;
      margin-left: 52px;
    }
  }
  .get-url {
    display: inline-block;
    font-size: 16px;
    margin-left: 20px;
    margin-top: 18px;
    font-weight: 600;
    padding: 12px 20px;
    background: #94ebf3;
    border-radius: 5px;
  }
  .teach-box {
    margin-top: 30px;
    .pro-box {
      display: flex;
      justify-content: space-between;
      .tip {
        flex: 1;
        font-size: 18px;
        font-weight: bolder;
      }
      img {
        width: 650px;
      }
    }
    .teach-title {
      font-size: 22px;
      font-weight: bold;
    }
    .num {
      width: 48px;
      height: 48px;
      background: #94ebf3;
      border-radius: 7px;
      text-align: center;
      line-height: 48px;
      font-weight: bold;
    }
    .detail {
      font-size: 18px;
      font-weight: 600;
      margin-left: 10px;
    }
    .teach-first-second {
      display: flex;
      margin-top: 38px;

      .step {
        display: flex;
        align-items: center;
      }
      .second {
        margin-left: 30px;
      }
    }
    .teach-second {
      display: flex;
      align-items: flex-start;
      margin-top: 58px;
      &-left {
        display: flex;
        align-items: center;
      }
      img {
        width: 200px;
      }
    }
    .teach-third {
      display: flex;
      align-items: flex-start;
      margin-top: 58px;
      img {
        width: 320px;
        height: 420px;
        margin-left: 53px;
      }
    }
    .teach-fourth {
      display: flex;
      align-items: flex-start;
      margin-top: 58px;
      &-left {
        display: flex;
        align-items: flex-start;
      }
      img {
        width: 476px;
        height: 249px;
        margin-left: 78px;
      }
    }
    .teach-fifth {
      display: flex;
      align-items: center;
      margin-top: 58px;
    }
  }
  .business {
    width: 1200px;
    margin-top: 20px;
  }
}
</style>